import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{#focus-manager autofocusSelector=this.autofocusSelector}}\n  {{yield}}\n{{/focus-manager}}", {
  moduleName: "@dashboard/shared-ui/components/deprecated/standard-modal-dialog.hbs"
});